<template>
  <div data-advanced-filters :class="$style.component">
    <base-select
      :class="$style.select"
      v-for="(item, index) in modelValue"
      :key="index"
      :label="item.label"
      :id="item.id"
      :options="item.options"
      @select="onSelect"
    />
    <div :class="$style.searchWrapper">
      <input
        data-testid="search"
        :placeholder="options.searchPlaceholder || 'Search...'"
        type="text"
        v-model="queryModel"
      />
    </div>
  </div>
</template>

<script>
import vueTypes from 'vue-types'
import BaseSelect from './BaseSelect'

export default {
  name: 'AdvancedFilters',

  props: {
    dropdowns: vueTypes.array,
    query: vueTypes.string,
    options: vueTypes.object.def({})
  },

  components: {
    BaseSelect
  },

  data() {
    return {
      modelValue: []
    }
  },

  watch: {
    dropdowns: {
      immediate: true,
      handler (value) {
        this.modelValue = value
      }
    }
  },

  computed: {
    queryModel: {
      get () {
        return this.query
      },
      set (value) {
        this.$emit('search', value)
      }
    }
  },

  methods: {
    onSelect (item) {
      this.$emit('select', item)
    }
  }
}
</script>

<style module>
  .searchWrapper {
    position: relative;

    input {
      border-radius: var(--border-radius-career-filter);
      padding: 0 20px 0 30px;
      box-sizing: border-box;
      height: 38px;
      min-width: 100%;
      max-width: 150px;
      border: 1px solid rgba(0, 0, 0, 0.05);
      font-size: 16px;
      margin: 0;
      color: black;
      background: rgba(255, 255, 255, 0.7);
      font-family: 'Inter', sans-serif;

      &::placeholder {
        color: $skyDark;
      }
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 13px;
      left: 11px;
      width: 13px;
      height: 12px;
      z-index: 1;
      background: url('./assets/icon-lens.png') no-repeat;
      background-size: 100%;
    }
  }

  .select {
    width: 100%;
    margin-bottom: 10px;
  }

  @media screen and (min-width: 480px) {
    .component {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
    }

    .select {
      margin: 0;
    }
  }

  @media screen and (min-width: 767px) {
    .component {
      max-width: 660px;
      grid-template-columns: repeat(4, 1fr);
    }

    .select {
      width: 150px;
    }
  }

  @media screen and (min-width: 960px) {
    .component {
      display: flex;
      max-width: 100%;
    }

    .select {
      margin-right: 10px;
    }
  }

</style>
